"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr) {
    return arr.reduce(function (obj, x) {
        Object.keys(x).forEach(function (key) {
            if (Array.isArray(obj[key])) {
                obj[key].push(x[key]);
            } else {
                obj[key] = [x[key]];
            }
        });
        return obj;
    }, {});
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/array/arrayToObject.js
// module id = 16
// module chunks = 0